// redux/notes/notes.reducer.js
import noteActionTypes from "./notes.types";

const INITIAL_STATE = {
  notes: [],
};

const noteReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case noteActionTypes.SET_NOTES:
      return {
        ...state,
        notes: action.payload,
      };
    default:
      return state;
  }
};

export default noteReducer;
